import { NSARouterMakerResult } from "namirasoft-account-react";
import { Component, ReactNode } from "react";
import { QuotaRouterProps } from "../QuotaRouterProps";
import { QuotaLayout } from "../QuotaLayout";
import { QuotaEntities } from "../QuotaEntities";

export interface RequestListPageProps extends NSARouterMakerResult, QuotaRouterProps { }

export class RequestListPage extends Component<RequestListPageProps>
{

    override render(): ReactNode
    {
        return (
            <QuotaLayout
                {...this.props}
                action={{
                    description: "This section displays all your submitted quota change requests with their current status and basic information.",
                    menus: {}
                }}
                pages={{
                    entity: QuotaEntities.request(this.props),
                    list: {
                        ui: {}
                    }
                }}
            >
                <></>
            </QuotaLayout>
        )
    }
}